module.exports = __webpack_public_path__ + "img/empty-search.a45afd7.png";